export default __webpack_public_path__ + "static/media/problem.a58f42d0.jpg";